import { render, staticRenderFns } from "./didnPbx.vue?vue&type=template&id=1a5d618d&"
import script from "./didnPbx.vue?vue&type=script&lang=js&"
export * from "./didnPbx.vue?vue&type=script&lang=js&"
import style0 from "./didnPbx.vue?vue&type=style&index=0&id=1a5d618d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports